import { lazy } from "react";

export const ManageTagsAsync = lazy(() => import("./ManageTags"));
